import { getWhitelistedQuery, Url } from 'utils/url';
import { verifyRequiredBetaFeaturesWithUserLoginStatus } from 'utils/betaFeatures/verifyRequiredBetaFeatures';

import { RAVEN_LOGGED_IN_HOMEPAGE_BETA_FEATURE } from '../loggedInHomepage/const';
import { LOGGED_OUT_HOMEPAGE_BETA_FEATURE } from './const';
import { USER_LOGIN_STATUS } from 'apps/user/helpers';
import gtmPageTypes from 'apps/gtm/utils/gtmPageTypes';

import LoggedOutHomePage from '[theme-lib]/apps/loggedOutHomePage/containers/LoggedOutHomePage';

const redirectToLegacyWebshopHomepage = verifyRequiredBetaFeaturesWithUserLoginStatus([
  { auth: USER_LOGIN_STATUS.LOGGED_IN, betaFeatures: [RAVEN_LOGGED_IN_HOMEPAGE_BETA_FEATURE] },
  { auth: USER_LOGIN_STATUS.LOGGED_OUT, betaFeatures: [LOGGED_OUT_HOMEPAGE_BETA_FEATURE] },
], { redirectOnReject: '/webshop/startWebshop.do' });

const redirectToRavenLoggedInHomepageWithQuery = (nextState, ...args) => {
  const loggedInUserHomepageWithQuery = new Url('/home')
    .addQueryParameters(getWhitelistedQuery(nextState.location.query))
    .toString();

  const ret = verifyRequiredBetaFeaturesWithUserLoginStatus([
    { auth: USER_LOGIN_STATUS.LOGGED_OUT, betaFeatures: [LOGGED_OUT_HOMEPAGE_BETA_FEATURE] },
  ], { redirectOnReject: loggedInUserHomepageWithQuery, setNoRouteAccessOnReject: false });

  return ret(nextState, ...args);
};

// Should be removed if alternative LOHP URL will be created
export const homepageLoggedOut = {
  component: LoggedOutHomePage,
  onEnterHandlers: [
    redirectToLegacyWebshopHomepage,
    redirectToRavenLoggedInHomepageWithQuery,
  ],
  gtmPageType: gtmPageTypes.Homepage,
  layoutFullWidth: true,
};
